import { render, staticRenderFns } from "./MAN901P02.vue?vue&type=template&id=0740841a&"
import script from "./MAN901P02.vue?vue&type=script&lang=js&"
export * from "./MAN901P02.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports